import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Loading,
  Text,
  TextField,
  Tabs,
  Badge,
  PageActions,
  Stack,
  Banner,
  Toast,
  Icon,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../Helpers";

const AccessPassword = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    password: "",
  });
  const handleChangePassword = (newValue) => {
    setItem({ ...item, password: newValue });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  useEffect(() => {
    axios
      .get(`settings/password-protection`)
      .then((result) => {
        setIsSaving(false);
        setItem({
          password: result?.data?.data?.password_restriction
            ? result?.data?.data?.password_restriction
            : "",
        });
      })
      .catch((err) => console.log(err));
  }, []);
  const handleSave = () => {
    setIsSaving(true);
    const form_data = new FormData();
    item.password && form_data.append("password_restriction", item.password);
    form_data.append("_method", "PATCH");
    axios
      .post(`settings/password-protection`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(""));
  };
  return (
    accessSettings() && (
      <Page title="Restrict store access">
        <Card sectioned>
          {isSaving ? <Loading /> : null}
          <FormLayout>
            <Banner status="info">
              <p>
                Your website is in development. To let visitors access your
                store, give them the password.
              </p>
            </Banner>
            {/* <Text variant="bodyMd" as="p" fontWeight="semibold">
            Password protection
          </Text> */}
            <TextField
              value={item.password}
              onChange={handleChangePassword}
              label="Password protection"
            />
          </FormLayout>
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
};

export default AccessPassword;
